import React, { useState } from 'react';
import {makeStyles} from '@mui/styles';
import {
  Button,
  ButtonGroup,
  CardActions,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@mui/material';

import PageHeader from "../../../components/PageHeader/PageHeader";
import Card from "../../../components/Card/Card";
import AddIcon from '@mui/icons-material/Add';
import { GridItem } from '../../../components/Grid';
import { useDispatch, useSelector } from 'react-redux';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import { LicenseListPanel } from '../UploadLicense/components/';
import {
  alertActions,
  licensingActions
} from '../../../store/actions';
import customSelectStyle from '../../../assets/jss/customSelectStyle';
import { history } from '../../../helpers/history';
import jwtDecode from 'jwt-decode';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  item: {
    padding: 20
  },
  content: {
    margin: 0,
    padding: 0,
    backgroundColor: '#FFF'
  },
  titleHeader: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.white
  },
  buttonReset: {
    margin: theme.spacing(3),
    color: theme.palette.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.light

    }
  },
  button: {
    margin: theme.spacing(3),
    color: theme.palette.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light

    }
  },
  ...customSelectStyle
}));

const UploadLicense = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [fileList, setFileList] = useState([]);
  const authenticatedUser = useSelector(state => state.authentication.user);
  const licensing = useSelector(state => state.licensing.data);

  const onHandleChange = event => {
    let files = event.target.files;
    setFileList(files);
  };

  async function getRandomPhrase(){
    return dispatch(licensingActions.generateRandomPhrase()).then(licensing =>{
      return (licensing);
    });
  }

  const onHandleUpload = () => {
    const formData = new FormData();
    formData.append('company', authenticatedUser.companyId);

    for (let i = 0; i < fileList.length; i++) {
        formData.append('fileList[]', fileList[i]);
    }

    setFileList([]);
    if (formData.getAll('fileList[]').length > 0 ) {
      dispatch(licensingActions.uploadLicenseFiles(formData)).then(
        async data => {
          if (data.failedUploads.length > 0) {
            dispatch(alertActions.error(data.message))
            history.push({
              pathname: '/license/error',
              state: {
                errorMessage: "Error uploading new license files.  " + data.message,
                user: authenticatedUser
              }
            });
          } else {
            let decodedData = jwtDecode(data.userData.token);
            if (decodedData.licenseResult === 1) {
              dispatch(alertActions.clear());
              history.push('/dashboard');
            } else {
              if (decodedData.licenseResult === 0) {
                dispatch(alertActions.error(decodedData.licenseMessage))
                history.push({
                  pathname: '/license/error',
                  state: {
                    errorCode: decodedData.licenseResult,
                    errorMessage: decodedData.licenseMessage
                  }
                });
              } else if (decodedData.licenseResult < 0) {
                dispatch(licensingActions.validateLicense(authenticatedUser, '/dashboard'))
              }
            }
          }
        }

      );

    }
  }

  const onHandleReset = () => {
    setFileList([]);
  };

  return (
    <div className={classes.root}>
      <PageHeader
        className={classes.titleHeader}
        title={"UPLOAD LICENSE FILE"}
        subTitle={"Upload License File and All Supporting Files"}
      />
      <Card className={classes.content}>
          <CardContent>
            <Grid />
            <CardActions>
              <GridItem>
                <Typography style={{ padding: 10 }} variant="h4">
                  Find license and/or signature files
                </Typography>
              </GridItem>
              <GridItem
                md={2}
                xs={12}
              >
                <form
                  encType="multipart/form-data"
                  method="post"
                >
                  <label htmlFor="select-file">
                    {(fileList.length === 0) &&
                      <div>
                        <GridItem
                          item
                          className={classes.item}
                        >
                          <input
                            accept=".bin,.txt"
                            id="select-file"
                            multiple="multiple"
                            name="select-file[]"
                            onChange={onHandleChange}
                            style={{ display: 'none' }}
                            type="file"
                          />
                          <Button
                            color="primary"
                            className={classes.button}
                            component="span"
                            variant="contained"
                          >
                            <AddIcon /> Browse
                          </Button>
                        </GridItem>
                      </div>
                    }
                  </label>
                </form>
                {fileList.length > 0 &&
                  <ButtonGroup>
                    <Button
                      color="success"
                      className={classes.button}
                      component="span"
                      onClick={onHandleUpload}
                      variant="contained"
                    >
                      <CloudUploadIcon/> Upload
                    </Button>
                    <Button
                      color="primary"
                      className={classes.buttonReset}
                      component="span"
                      onClick={onHandleReset}
                      variant="contained"
                    >
                      <RotateLeftIcon/> Reset
                    </Button>
                  </ButtonGroup>
                }
              </GridItem>
            </CardActions>
            <Divider />
            {fileList.length > 0 &&
              <LicenseListPanel
                classes={classes}
                fileList={fileList}
              />
            }
          </CardContent>

      </Card>
    </div>
  );
};

export default UploadLicense;
